
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Loading from '../../loading';
import SimplePieChart from './pieChart';
import { styles } from './styles';
import Toolbar from './toolbar';


class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }
    } 
    fetchData= async (from, to) => {
        this.loading.startLoading()
        await this.props.bookingDispatch.statisticsBooking({ 
            from:  new Date(moment(from).startOf('month').valueOf()).setHours(0,0,0,0),
            to: new Date(moment(to).endOf('month').valueOf()).setHours(29,59,59,999),
        });
        this.loading.stopLoading()
    }
    render() { 
        const { classes, theme, t } = this.props;
        const statistics = this.props.bookingState.statistics;
        
        let statusArray = [
            {
                name: 'checking',
                key: "checking",
                value: 0,
                color: 'rgb(251, 140, 0)'
            },
            {
                name: 'missed',
                key: "missed",
                value: 0,
                color: '#aea7a7'
            },
            {
                name: 'cancel',
                key: "cancel",
                value: 0,
                color: '#d03535'
            },
            {
                name: 'confirm',
                key: "confirm",
                value: 0,
                color: '#2d94b2'
            },
            {
                name: 'success',
                key: "success",
                value: 0,
                color: '#82c14d'
            }
        ];

        let totalBooking = 0;
        if (statistics.length) {
            statusArray.map((status, i1) => {
                statistics.map((booking, i2) => {
                    if(booking._id === status.key) {
                        totalBooking += booking.count;
                        status.value += booking.count;
                    }
                })
            })
        }
        
        
        return (
            <div className={classes.containerPaper}>
                <Paper className={classes.root}>
                 <Loading onRef={id => (this.loading = id)}/>
                    <Toolbar total={totalBooking} fetchData = {this.fetchData}/>
                    <div className={classes.container}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={4}>
                                <div className={classes.colStatus}>
                                    {statusArray.map((item, index) => {
                                        return (
                                            <div className={classes.row_info} key={index}>
                                                <span className={classNames(classes['square' + '_' + statusArray[index].key], classes.square)}></span>
                                                <span className={classes.infoTitle}>{t(item.key)}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} style={{ 'overflow': 'auto', textAlign: 'right' }}>
                                <SimplePieChart data={statusArray} id='dashboard-bookingchart'/>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </div>
        )
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
const mapState = state => ({
    bookingState: state.booking
});

const mapDispatch = dispatch => ({
    bookingDispatch: dispatch.booking
});


export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(Dashboard)));